import { render, staticRenderFns } from "./GameEdit.vue?vue&type=template&id=2067347d&"
import script from "./GameEdit.vue?vue&type=script&lang=js&"
export * from "./GameEdit.vue?vue&type=script&lang=js&"
import style0 from "./GameEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports